export default __webpack_public_path__ + "static/media/Header.819c123b.png";